import {Component, HostBinding, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {Map} from 'leaflet';
import {MapTileType} from '../map-settings-types';
import {MapTileLayerSettingsService} from './map-tile-layer-settings.service';
import {AuthorizationService} from '../../authorization/authorization.service';
import {MapLayersService} from '../../shared/map-layers.service';

@Component({
  selector: 'app-map-services',
  templateUrl: './map-services.component.html',
})
export class MapServicesComponent implements OnInit {
  @HostBinding('class.map-services') true;
  mapToggleContainerState = false;
  @Input() map: Map;
  lastLayer: L.TileLayer | null = null;

  constructor(
    public mapTileLayerSettingsService: MapTileLayerSettingsService,
    public authorizationService: AuthorizationService,
    public mapLayersService: MapLayersService,
    @Inject(LOCALE_ID) protected locale,
  ) {
    this.mapLayersService.controlGeoObjectsVisibility.subscribe(() => this.mapToggleContainerState = false);
  }

  toggleMap() {
    this.mapToggleContainerState = !this.mapToggleContainerState;
  }

  chosenMap(id: MapTileType) {
    this.mapTileLayerSettingsService.chosenMapTileType.next(id);
    this.mapTileLayerSettingsService.setChosenMapTypeToLocalStorage(id);
  }

  ngOnInit() {
    this.mapTileLayerSettingsService.currentTileLayer.subscribe(layer => {
      if (this.lastLayer) {
        this.map.removeLayer(this.lastLayer);
      }

      layer.addTo(this.map).bringToFront();

      this.lastLayer = layer;
    });
  }
}
